module.exports = __webpack_public_path__ + "img/Volans.eea3e996.png";